__webpack_require__.p = "/Projet-Diabete-IA/";